import './Dashboard.scss';
import { Col, Row, Spin } from 'antd';
import CardsDashboard from '../../components/upeosoft/CardsDashboard/CardsDashboard';
import SectionHeroDashboard from '../../components/upeosoft/SectionHeroDashboard/SectionHeroDashboard';
import { getDashboard } from '../../network/dashboard';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';
import { getSalesInvoices } from '../../network/salesInvoice';
import RevenueAnalysis from './RevenueAnalysis';
import DashboardTable from './DashboardTable';
import VisitsSource from './VisitsSource';
import ConfigAos from '../../hooks/ConfigAos';
import SalesOrder from './SalesOrder';
import DashboardTableCustomers from './DashboardTableCustomers';
import DashboardTableItems from './DashboardTableItems';
import DashboardTableSuppliers from './DashboardTableSuppliers';
import DashboardCards from './DashboardCards';

const Dashboard = ({ t }) => {
  // getDashboard;
  const { currentLang, practitioner } = useSelector((state) => state.user);
  // const { practitioner } = useSelector((state) => state.user);
  // console.log('practitioner:', practitioner);
  const { data: salesInvoices, isLoading: isLoadingInvoice } = useQuery({
    queryKey: [queryKeys.getSalesInvoices, currentLang, ''],
    queryFn: () => getSalesInvoices('status', 'Draft', currentLang),
    keepPreviousData: true,
  });
  console.log('salesInvoices:', salesInvoices);

  const { data: dashboardData, isLoading } = useQuery({
    queryKey: [queryKeys.getDashboard],
    queryFn: () => getDashboard(),
  });
  if (isLoading || isLoadingInvoice) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }
  return (
    <ConfigAos>
      <div className="overflow-hidden">
        {/* <SectionHeroDashboard t={t} /> */}
        {/* <CardsDashboard
          t={t}
          dataCards={dashboardData?.message?.main_header || []}
        /> */}
        <DashboardCards t={t} />
        <Row gutter={[15, 10]} className="mt-[20px]">
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={16}
            data-aos="fade-right"
            data-aos-delay="150"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <RevenueAnalysis
              t={t}
              dataSales={dashboardData?.message ? dashboardData?.message : {}}
            />
          </Col>
          <Col
            sm={24}
            md={24}
            lg={24}
            xl={8}
            data-aos="fade-left"
            data-aos-delay="150"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <SalesOrder
              dataSales={dashboardData?.message ? dashboardData?.message : {}}
              t={t}
            />
          </Col>
        </Row>
        <Row gutter={[15, 10]} className="mt-[20px]">
          <Col
            xs={24}
            sm={24}
            md={12}
            data-aos="fade-up"
            data-aos-delay="150"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <DashboardTableCustomers
              t={t}
              dataCustomers={
                dashboardData?.message?.top_customers
                  ? dashboardData?.message?.top_customers
                  : []
              }
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <DashboardTableSuppliers
              t={t}
              dataSuppliers={
                dashboardData?.message?.top_suppliers
                  ? dashboardData?.message?.top_suppliers
                  : []
              }
            />
            {/* <DashboardTableItems
            t={t}
            dataItems={dashboardData?.message?.top_items_sold}
          /> */}
          </Col>
        </Row>

        <Row gutter={[15, 10]} className="mt-[20px]">
          <Col
            xs={24}
            sm={24}
            md={12}
            data-aos="fade-right"
            data-aos-delay="200"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <VisitsSource
              t={t}
              data={dashboardData?.message?.top_items_sold || []}
              type="sold"
            />
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            data-aos="fade-left"
            data-aos-delay="200"
            data-aos-duration="400"
            data-aos-easing="linear"
            data-aos-once="true"
          >
            <VisitsSource
              t={t}
              data={dashboardData?.message?.top_items_purchased || []}
              type="purchased"
            />
          </Col>
        </Row>
      </div>
    </ConfigAos>
  );
};

export default Dashboard;
